// store/modules/tabs.js
export default {
    namespaced: true,
    state: {
        visitedViews: [],   // 已打开的标签页列表
        currentView: ''     // 当前激活的标签路径
    },
    mutations: {
        ADD_VIEW(state, view) {
            // 如果已存在相同 path 的标签，则不重复添加
            const exists = state.visitedViews.some(v => v.path === view.path)
            if (!exists) {
                state.visitedViews.push({ ...view })
            }
        },
        REMOVE_VIEW(state, path) {
            const index = state.visitedViews.findIndex(v => v.path === path)
            if (index !== -1) state.visitedViews.splice(index, 1)
        },
        SET_CURRENT_VIEW(state, path) {
            state.currentView = path
        },
        CLOSE_OTHERS(state, path) {
            state.visitedViews = state.visitedViews.filter(v => v.path === path)
        },
        CLOSE_ALL(state) {
            state.visitedViews = []
        }
    }
}